/**
 * Nome legível da audiência de uma campanha, para a lista.
 *
 * `audience` guarda referência, não nome: `Label` traz só o id, e resolver esse id contra os
 * rótulos da conta é o que transforma "1" em "teste-fase2" na tela. As outras fontes já chegam
 * nomeadas (`list_name`) ou não têm nome nenhum — planilha e lista digitada viram um rascunho no
 * backend Go, e o que identifica a campanha ali é o título, não a audiência.
 */
export const AUDIENCE_SOURCES = {
  LABEL: 'Label',
  HUBSPOT: 'hubspot_segment',
  DRAFT: 'outbound_campaign',
};

export function audienceLabel(audience, labels = []) {
  const entry = Array.isArray(audience) ? audience[0] : null;
  if (!entry) return '';

  if (entry.type === AUDIENCE_SOURCES.HUBSPOT) {
    return entry.list_name || '';
  }

  if (entry.type === AUDIENCE_SOURCES.LABEL) {
    // Comparação frouxa de propósito: o id vem número do store e string do payload da campanha.
    // Com `===` o rótulo nunca casa e a coluna fica vazia sem erro nenhum.
    // eslint-disable-next-line eqeqeq
    const label = labels.find(item => item.id == entry.id);
    return label?.title || '';
  }

  return '';
}
